import React, { useState, useEffect } from "react";
import SinglePrescription from "./SinglePrescription";
import ApiService from "../../../../ApiService";
import { Button } from "react-bootstrap";
import ERXModal from "../../../Modal/eRx/ERXModal";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function formatDate(inputDate) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const date = new Date(inputDate);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date
    .getFullYear()
    .toString()
    .substr(-2);

  return `${day} ${month} '${year}`;
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

async function createPatientOnPhoton(userDetail, sexAtBirth) {
  return await ApiService.createPatientOnPhoton({
    patientId: userDetail?.subUUID,
    firstName: userDetail?.givenName,
    lastName: userDetail?.familyName,
    dob: userDetail?.birthDate,
    sex: sexAtBirth,
    phone: userDetail?.phoneNumber,
    email: userDetail?.email,
    gender: userDetail?.gender,
    address: {
      name: {
        first: userDetail?.givenName,
        last: userDetail?.familyName
      },
      street1: userDetail?.address?.street_address,
      street2: userDetail?.address?.street_address2,
      postalCode: userDetail?.address?.postal_code,
      country: "USA",
      state: userDetail?.address?.region,
      city: userDetail?.address?.locality
    }
  });
}

function determineSexAtBirth(genderAtBirth) {
  const genderLower = genderAtBirth?.toLowerCase();
  if (genderLower?.includes("male")) return "MALE";
  if (genderLower?.includes("female")) return "FEMALE";
  return "UNKNOWN";
}

export default function Prescription({ patientId, patientEmail, patientDetail }) {
  const [prescriptions, setPrescriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxId, setERxId] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("success");
  const [snackText, setSnackText] = useState("");

  const fetchPres = async () => {
    try {
      setIsLoading(true);
      const res = await ApiService.getPatientPrescriptions(patientId);
      console.log(res);
      setPrescriptions(res?.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchPres();
  }, [patientId]);

  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };

  const handleSendPrescription = async patientEmail => {
    try {
      const userDetailRes = await ApiService.getPatientDetailByEmail(patientEmail);
      const userDetail = userDetailRes?.data;

      if (!userDetail) {
        setSnackOpen(true);
        setSnackSeverity("error");
        setSnackText("Patient account not found");
        return;
      }

      const photonHealthErxPatientId = userDetail?.photonHealthErxPatientId;
      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
        return;
      }

      const sexAtBirth = determineSexAtBirth(userDetail?.genderAtBirth);
      const eRxIdRes = await createPatientOnPhoton(userDetail, sexAtBirth);

      if (eRxIdRes?.data?.erxPhotonId?.id) {
        setShowErxModal(true);
        setERxId(eRxIdRes?.data?.erxPhotonId?.id);
        ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id)
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    } catch (err) {
      console.error("Error in handleSendPrescription:", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  return (
    <div className="dashboardContent">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "10px 20px"
        }}
      >
        <Button
          variant="success"
          onClick={() => {
            handleSendPrescription(patientEmail);
          }}
        >
          Create New Prescription
        </Button>
      </div>
      {showErxModal && <ERXModal eRxid={eRxId} onHide={hideErxModal} />}
      <div
        className="tabsContent"
        style={{
          padding: "10px 20px"
        }}
      >
        {prescriptions.length > 0 && !isLoading ? (
          <>
            {prescriptions?.map(
              (el, index) => (
                console.log(el),
                (
                  <SinglePrescription
                    key={index}
                    status={el.state}
                    presName={el.treatment?.name}
                    isClinicalRequired={false}
                    instruction={el?.instructions}
                    authorDetails={el?.prescriber}
                    notes={el?.notes}
                    createdDate={formatDate(el?.writtenAt)}
                    presId={el?.id}
                    orderStatus={el?.fills?.length > 0 ? el?.fills[0]?.order?.state : "N/A"}
                  />
                )
              )
            )}
          </>
        ) : (
          <div className="tabsContent">{isLoading ? <div className="loading"></div> : <h1 className="noRecordFound">No Prescription Found</h1>}</div>
        )}
      </div>
      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={() => {
          setSnackOpen(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => {
            setSnackOpen(false);
          }}
          severity={snackSeverity}
        >
          {snackText}
        </Alert>
      </Snackbar>
    </div>
  );
}
